module.exports = __webpack_public_path__ + "img/basics3.25bafd71.png";